// Map des shortnames vers leur path SEO canonical
const seoPathMap = {
  'home': '/',
  'currentMenu': '/ventes-ephemeres',
  'about': '/a-propos-de-Sophie-Minotto-cuisine-vegetale-et-creative',
  'howToOrder': '/comment-commander',
  'prestations': '/prestations-cheffe-a-domicile-traiteur-vegetarien',
  'privatechef': '/cheffe-privee-vercors',
  'traiteurvegetarien': '/traiteur-vegetarien-gourmand',
  'cuisiniereSejour': '/cuisinere-retraites-yoga-sejours-bien-etre-sportif',
  'traiteurEntreprise': '/traiteur-entreprise-seminaire-team-building-vegetarien-sain-haut-de-gamme-coktail-ecoresponsable',
  'traiteurVegan': '/traiteur-cheffe-privee-vegan-sans-allergenes',
  'traiteurSansLactose': '/cheffe-traiteur-sans-lactose',
  'news': '/actualites-evenements-popups--autour-du-gout',
  'contact': '/contacter-Sophie-Minotto-cheffe-privee-Vercors',
  'allergenes': '/allergenes',
  'termsAndConditions': '/conditions-generales-de-vente',
  'legal': '/legal',
  'partenaires': '/partenaires',
};

// Inverse map : ancien path -> path SEO canonical
const oldPathToSeoPath = {};
const oldPaths = {
  '/a-propos': 'about',
  '/prestations': 'prestations',
  '/menu-de-la-semaine': 'currentMenu',
  '/vente-ephemere': 'currentMenu',
  '/news': 'news',
  '/actualites': 'news',
  '/me-contacter': 'contact',
  '/contact': 'contact',
  '/traiteur-cheffe-privée-vegan-sans-allergenes': 'traiteurVegan',
};
for (const [oldPath, shortname] of Object.entries(oldPaths)) {
  oldPathToSeoPath[oldPath] = seoPathMap[shortname];
}

/**
 * Retourne le path SEO canonical pour un shortname donné.
 * Si le shortname n'existe pas dans la map, retourne null.
 */
export function getSeoPath(shortname) {
  return seoPathMap[shortname] || null;
}

/**
 * Remplace un path par sa version SEO canonical si elle existe.
 * Utile pour les liens internes.
 */
export function toSeoPath(path) {
  if (oldPathToSeoPath[path]) {
    return oldPathToSeoPath[path];
  }
  return path;
}

export default seoPathMap;
